import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import Glyphicon from "../Glyphicon";

class InfoWindowSpanie extends PureComponent<any> {
  render() {
    const { id, sleepingGuide } = this.props;
    if (!sleepingGuide) return null;
    return (
      <section className="InfoWindowSpanie">
        <Glyphicon className="InfoWindowSpanie_icon" icon="airline_seat_flat" />
        Poradnik:{" "}
        <a
          href={
            "http://tambylstwo.blogspot.com/2010/06/sztuka-taniego-latania-spanie-na.html#" +
            id
          }
          title="Zobacz poradnik"
          className="InfoWindowSpanie_link"
        >
          spanie na lotnisku
        </a>
      </section>
    );
  }
}

export default InfoWindowSpanie;
